import { defineFcm } from '../shared/factory';

export const FCM_SEARCH_V2_MAINTENANCE = defineFcm('search_v2_maintenance').asBoolean().withDefault(false).toConfig();
